/* Реєстр текстів: внутрішні сторінки сайту. Формат поля —
   [ключ, підпис в адмінці, текст за замовчуванням]. Див. siteTexts.js. */

const RETURNS = { id: 'returns', label: 'Дохідність', path: '/returns', sections: [
  { id: 'returns.hero', label: 'Перший екран', fields: [
    ['badge', 'Мітка', 'Дохідність'],
    ['title', 'Заголовок', 'Реальні цифри стратегії\nна реальних даних'],
    ['num_cap', 'Підпис біля великого числа', 'на рік — незалежно\nвід дати старту'],
    ['lead', 'Текст', 'Тут можна ознайомитись з дохідністю нашої актуальної стратегії торгів на історичних (минулих) даних цін на акції на різних періодах.'],
    ['chart_title', 'Картка-графік: заголовок', 'Портфель · Interactive Brokers'],
    ['chart_live', 'Картка-графік: статус', 'Алгоритм працює'],
    ['chart_buy', 'Картка-графік: мітка купівлі', 'Купівля'],
    ['chart_sell', 'Картка-графік: мітка продажу', 'Продаж'],
    ['chart_value', 'Картка-графік: підпис вартості', 'Вартість портфеля'],
    ['chart_badge', 'Картка-графік: мітка росту', '+{returns_num}% за рік'],
  ] },
  { id: 'returns.calc', label: 'Калькулятор: заголовок', fields: [
    ['title', 'Заголовок', 'Перевірте дохідність на своєму періоді'],
    ['subtitle', 'Підзаголовок', 'Треба вибрати період мінімум довжиною в рік, у діапазоні дат від 01.01.2020 до вчорашньої дати.'],
    ['total_label', 'Підпис підсумку', 'Загальна сума за обраний період'],
  ] },
  { id: 'returns.marquee', label: 'Бігучий рядок принципів', fields: [
    ['p1', 'Принцип 1', 'Не day-trading'],
    ['p2', 'Принцип 2', 'Реінвестування прибутку'],
    ['p3', 'Принцип 3', 'Однакові правила і алгоритми'],
    ['p4', 'Принцип 4', 'Купуємо потенціал росту'],
    ['p5', 'Принцип 5', 'Продаємо з прибутком'],
    ['p6', 'Принцип 6', '{returns_claim} на рік'],
    ['p7', 'Принцип 7', 'Кількість угод невелика'],
  ] },
  { id: 'returns.trust', label: '01 · Достовірність і прозорість', fields: [
    ['title', 'Заголовок', 'Достовірність і прозорість'],
    ['c1_title', 'Картка 1: заголовок', 'Дані достовірні'],
    ['c1_text', 'Картка 1: текст', 'Стратегія торгується на історичних даних, дані достовірні, алгоритми актуальні.'],
    ['c2_title', 'Картка 2: заголовок', 'Деталізація в офісі'],
    ['c2_text', 'Картка 2: текст', 'При потребі, при відвідуванні нашого офісу (інформація не на загал), ми можемо показати деталізовано будь-які ці торги на архівних даних — які акції, коли та за якою ціною купувалися і продавалися, графіки тощо.'],
    ['c3_title', 'Картка 3: заголовок', 'Все видно при реальних торгах'],
    ['c3_text', 'Картка 3: текст', 'При реальних торгах на вашому акаунті ви будете бачити всю цю інформацію.'],
  ] },
  { id: 'returns.entry', label: '02 · Чому дохідність залежить від точки входу', fields: [
    ['title', 'Заголовок', 'Чому дохідність залежить від точки входу'],
    ['sub', 'Підзаголовок', 'Залежно від точки входу (дати початку торгів) виходять різні дохідності. Умовні приклади:'],
    ['s1_tag', 'Приклад 1: мітка', 'Старт сьогодні'],
    ['s1_e1_t', 'Приклад 1, подія 1: коли', 'День 0'],
    ['s1_e1', 'Приклад 1, подія 1: що', 'Купівля: компанії 1-2-3-4-5-6-12-x'],
    ['s1_e2_t', 'Приклад 1, подія 2: коли', '+1 місяць'],
    ['s1_e2', 'Приклад 1, подія 2: що', 'Продаж 1 → купівля 345'],
    ['s1_e3_t', 'Приклад 1, подія 3: коли', '+1,5 місяця'],
    ['s1_e3', 'Приклад 1, подія 3: що', 'Продаж 3 → купівля 1204'],
    ['s1_e4_t', 'Приклад 1, подія 4: коли', '+4 місяці'],
    ['s1_e4', 'Приклад 1, подія 4: що', 'Продаж 12 → купівля 75'],
    ['s2_tag', 'Приклад 2: мітка', 'Старт завтра'],
    ['s2_e1_t', 'Приклад 2, подія 1: коли', 'День 0'],
    ['s2_e1', 'Приклад 2, подія 1: що', 'Купівля: компанії 45-3056-895-7-18-479'],
    ['s2_e2_t', 'Приклад 2, подія 2: коли', '+2 тижні'],
    ['s2_e2', 'Приклад 2, подія 2: що', 'Продаж 895 → купівля 1106'],
    ['s2_e3_t', 'Приклад 2, подія 3: коли', '+1,5 місяця'],
    ['s2_e3', 'Приклад 2, подія 3: що', 'Продаж 45 → купівля 725'],
    ['s2_e4_t', 'Приклад 2, подія 4: коли', '+5 місяців'],
    ['s2_e4', 'Приклад 2, подія 4: що', 'Продаж 725 → купівля 4839'],
    ['note', 'Текст під прикладами', 'Тобто дата початку торгів визначає всю подальшу майбутню торгівлю, яка буде не схожа в плані дат/акцій на торгівлю такою ж сумою, яку почали б через день чи в будь-який інший день.'],
    ['concl', 'Висновок (*фраза* — виділення)', 'Визначити достеменно, в який день краще почати, неможливо — але незалежно від дати початку це буде дохідність *{returns_claim} на рік*'],
    ['rules_title', 'Картка «правила»: заголовок', 'Однакові правила й алгоритми'],
    ['rules_text', 'Картка «правила»: текст', 'В усій торгівлі застосовуються однакові правила й алгоритми:'],
    ['rule_buy', 'Картка «правила»: купівля', 'Купуються акції, які мають більший потенціал до росту'],
    ['rule_sell', 'Картка «правила»: продаж', 'Продаються (з прибутком) ті, які вже мають менший потенціал для росту'],
    ['dt_title', 'Картка «не day-trading»: заголовок', 'Це не Day-trading'],
    ['dt_text', 'Картка «не day-trading»: текст', 'Кількість угод на місяць невелика — потрібен час, щоб акції виростали в ціні. Наша торгівля — це не Day-trading (щоденний денний трейдинг).'],
  ] },
  { id: 'returns.credit', label: '03 · Кредитне плече', fields: [
    ['badge', 'Мітка', 'Важливо'],
    ['title', 'Заголовок', 'Кредитне плече 1:2'],
    ['text', 'Текст', 'За бажанням в Interactive Brokers можна і бажано взяти кредит для торгів під приблизно 6% річних. Кредит надається в будь-якому обсязі, що не перевищує ваші особисті кошти: якщо ви вклали $1\u00a0000 — можете взяти ще до $1\u00a0000 кредиту і відповідно збільшити дохідність відносно вкладених коштів.'],
    ['fine', 'Дрібний текст', 'У всіх розрахунках і прикладах це кредитне плече 1:2 не враховується.'],
  ] },
  { id: 'returns.compound', label: '04 · Складний відсоток', fields: [
    ['title', 'Заголовок', 'Так працює складний відсоток'],
    ['axis', 'Підпис під діаграмою', '12 місяців · 3% на місяць · реінвест'],
    ['q_badge', 'Мітка питання', 'Питання'],
    ['q', 'Питання', 'Чому, умовно, щомісячна дохідність указана, наприклад, 3%, а в рік при цій дохідності — 42%? Якщо 3% скласти 12 разів (12 місяців), буде 36%, а не 42%.'],
    ['a_badge', 'Мітка відповіді', 'Відповідь'],
    ['a', 'Відповідь', 'У наших розрахунках усі кошти одразу реінвестуються (зароблені 3% одразу йдуть у роботу при наступній закупівлі), тому відсотки треба не додавати, а множити: 100% × 1.03 × 1.03 × 1.03 … і так 12 разів = 142% (42% річних). Так працює складний відсоток — відсотки з вкладення плюс відсотки з відсотків.'],
  ] },
  { id: 'returns.verify', label: '05 · Як перевірити дохідність', fields: [
    ['title', 'Заголовок', 'Як перевірити, чи дійсно наші стратегії дохідні'],
    ['sub', 'Підзаголовок', 'На прикладі віртуальних торгів.'],
    ['graph_label', 'Графік: заголовок', 'Графік дохідності'],
    ['graph_ours', 'Графік: легенда', 'Наш алгоритм'],
    ['note_before', 'Текст під графіком: початок', 'Запустіть віртуальні торги і чекайте. Дивитися на результати потрібно'],
    ['note_3m', 'Текст під графіком: кнопка 3 міс.', 'мінімум через три місяці'],
    ['note_6m', 'Текст під графіком: кнопка 6 міс.', 'бажано через пів року'],
    ['note_1y', 'Текст під графіком: кнопка рік', 'краще через рік'],
    ['note_after', 'Текст під графіком: кінець', '— акціям потрібен час, щоб вирости в ціні.'],
    ['tip_badge', 'Підказка: мітка', 'Підказка'],
    ['tip', 'Підказка: текст', 'До моменту торгів реальними коштами, при потребі, при відвідуванні нашого офісу (інформація не на загал), ми можемо відкрити всі ваші дані по ваших віртуальних торгах на вашому акаунті для підтвердження дохідності.'],
  ] },
  { id: 'returns.notify', label: 'Звіт раз на три місяці', fields: [
    ['mail_text', 'Приклад повідомлення (пошта)', 'Звіт про дохідність за квартал'],
    ['tg_text', 'Приклад повідомлення (Telegram)', 'Ваш портфель за 3 місяці'],
    ['title', 'Заголовок', 'Звіт про дохідність — раз на три місяці'],
    ['text', 'Текст', 'За вашим бажанням ви можете отримувати повідомлення раз на три місяці про дохідність на електронну пошту та/або в Телеграм (задається в налаштуваннях).'],
  ] },
] };


const cta = (page, title, subtitle) => ({ id: `${page}.cta`, label: 'Заклик унизу сторінки', fields: [
  ['title', 'Заголовок', title],
  ['subtitle', 'Текст', subtitle],
  ['secondary', 'Кнопка зліва', 'Дивитись дохідність'],
  ['primary', 'Кнопка справа', 'Створити акаунт'],
] });

const GUARANTEES = { id: 'guarantees', label: 'Гарантії', path: '/guarantees', sections: [
  { id: 'guarantees.hero', label: 'Перший екран', fields: [
    ['badge', 'Мітка', 'Гарантії'],
    ['title', 'Заголовок', 'Ваш капітал під\nнадійним захистом'],
    ['num_cap', 'Підпис біля «100%»', 'ваші кошти завжди\nзалишаються вашими'],
    ['lead', 'Текст', 'Ми побудували роботу так, щоб ваші кошти завжди залишалися вашими — на вашому рахунку, застраховані та під вашим контролем. Ось як саме.'],
    ['shield_title', 'Картка-щит: заголовок', 'Захист вашого капіталу'],
    ['shield_live', 'Картка-щит: статус', 'Захист активний'],
    ['ring1', 'Картка-щит: кільце 1', 'Interactive Brokers'],
    ['ring2', 'Картка-щит: кільце 2', 'SIPC · $500 000'],
    ['ring3', 'Картка-щит: кільце 3', 'Lloyd’s · $30 000 000'],
    ['shield_value', 'Картка-щит: підпис суми', 'Максимальний захист'],
    ['shield_badge', 'Картка-щит: мітка', 'SIPC + Lloyd’s'],
  ] },
  { id: 'guarantees.marquee', label: 'Бігучий рядок', fields: [
    ['p1', 'Пункт 1', 'Кошти на вашому рахунку в IB'],
    ['p2', 'Пункт 2', 'Захист SIPC до $500 000'],
    ['p3', 'Пункт 3', 'Додатково Lloyd’s of London до $30 000 000'],
    ['p4', 'Пункт 4', 'Доступ лише для торгівлі'],
    ['p5', 'Пункт 5', 'Гарантія від програшу вкладених коштів'],
    ['p6', 'Пункт 6', 'Наші інтереси збігаються з вашими'],
  ] },
  { id: 'guarantees.ib', label: '01 · Активи в Interactive Brokers', fields: [
    ['title', 'Заголовок секції', 'Активи на вашому рахунку в Interactive Brokers'],
    ['card_title', 'Картка: заголовок', 'Усі ваші акції та кошти зберігаються на вашому особистому рахунку'],
    ['card_text', 'Картка: текст', 'Interactive Brokers (IB) — один із найбільших і найнадійніших брокерів світу. Ми не зберігаємо ваші кошти й не маємо до них прямого доступу.'],
    ['stat1', 'Підпис числа 1', 'Активних клієнтських рахунків'],
    ['stat2', 'Підпис числа 2', 'Активів клієнтів на зберіганні'],
  ] },
  { id: 'guarantees.insure', label: '02 · Акції та кошти застраховані', fields: [
    ['title', 'Заголовок', 'Акції та кошти застраховані'],
    ['c1_amount', 'Картка 1: сума', 'до $500 000'],
    ['c1_title', 'Картка 1: заголовок', 'Захист SIPC'],
    ['c1_text', 'Картка 1: текст', 'Цінні папери та готівка застраховані Корпорацією із захисту інвесторів у цінні папери (SIPC). До $250 000 із цієї суми покривається у вигляді готівкових коштів.'],
    ['c2_amount', 'Картка 2: сума', 'до $30 000 000'],
    ['c2_title', 'Картка 2: заголовок', 'Lloyd’s of London'],
    ['c2_text', 'Картка 2: текст', 'Додатковий захист від дефолту брокера через синдикат Lloyd’s of London — до $30 млн на рахунок (ліміт $900 000 на неінвестовану готівку).'],
    ['c3_amount', 'Картка 3: сума', 'Segregation'],
    ['c3_title', 'Картка 3: заголовок', 'Роздільне зберігання'],
    ['c3_text', 'Картка 3: текст', 'Клієнтські активи відокремлені від коштів компанії. У разі банкрутства брокера ваші акції та облігації переводяться до депозитарію іншого брокера.'],
  ] },
  { id: 'guarantees.access', label: '03 · Доступ лише до торгівлі', fields: [
    ['title', 'Заголовок', 'Доступ лише до торгівлі — не до виведення коштів'],
    ['sub', 'Підзаголовок', 'Ви надаєте нам доступ виключно для здійснення торгів. Повного доступу до рахунку в нас немає — а отже, немає й технічної можливості вивести ваші кошти.'],
    ['p1', 'Пункт 1', 'Виведення коштів можливе лише на банківський рахунок, відкритий на ваше ім’я — це правило Interactive Brokers.'],
    ['p2', 'Пункт 2', 'Ви можете відключити нас від торгів будь-якої миті в адмінпанелі Interactive Brokers.'],
    ['p3', 'Пункт 3', 'Щотижня IB надсилає вам у застосунок запит на підтвердження дозволу на торги — ви можете просто не підтверджувати його.'],
    ['m_row1', 'Макет: рядок 1', 'Дозвіл на торгівлю'],
    ['m_row2', 'Макет: рядок 2', 'Щотижневе підтвердження'],
    ['m_row2_sub', 'Макет: підпис рядка 2', 'Автоматичний запит від IB'],
    ['m_note', 'Макет: примітка', 'Ви можете вимкнути доступ будь-якої миті.'],
  ] },
  { id: 'guarantees.prot', label: '04 · Гарантія захисту вкладених коштів', fields: [
    ['title', 'Заголовок', 'Гарантія захисту особисто вкладених коштів'],
    ['lead', 'Текст', 'У найгіршому випадку ми компенсуємо різницю, щоб сума на вашому рахунку ніколи не була меншою за всі ваші особисті вкладення за весь період.'],
    ['note_k', 'Примітка: мітка', 'Як це працює'],
    ['note', 'Примітка: текст', 'Від загальної суми на рахунку віднімається весь зароблений нами для вас прибуток. Якщо результат виявиться меншим за ваші вкладення — ми компенсуємо нестачу.'],
    ['c1_title', 'Картка 1: заголовок', 'Імовірність < 1%'],
    ['c1_text', 'Картка 1: текст', 'На нашу думку, ймовірність такої ситуації менша за 1%, але ми проговорюємо її для вашого спокою.'],
    ['c2_title', 'Картка 2: заголовок', 'Термін — 1 рік'],
    ['c2_text', 'Картка 2: текст', 'Компенсація через рік від запиту на повернення, щоб ми мали час відіграти нестачу. Приклад: ви втратили 10%, ми повернули їх за місяць, а за наступні 3 місяці рахунок усе одно виріс би на +18%.'],
    ['c3_title', 'Картка 3: заголовок', 'Нотаріальне засвідчення'],
    ['c3_text', 'Картка 3: текст', 'Для сум від $10 000 можливе нотаріальне засвідчення наших гарантій і зобов’язань — із повною юридичною силою.'],
    ['c4_title', 'Картка 4: заголовок', 'Особиста зустріч'],
    ['c4_text', 'Картка 4: текст', 'За потреби — особиста зустріч із керівником проєкту в офісі Trading.com.ua в м. Рівне.'],
  ] },
  { id: 'guarantees.inc', label: '05 · Наші інтереси збігаються з вашими', fields: [
    ['title', 'Заголовок', 'Наші інтереси збігаються з вашими'],
    ['text', 'Текст', 'Ми отримуємо комісію лише від вашого прибутку. Тому ми максимально зацікавлені збільшувати його — **це однаково вигідно і вам, і нам.**'],
    ['you', 'Вам: підпис', 'Вам'],
    ['you_v', 'Вам: що', 'більший прибуток'],
    ['we', 'Нам: підпис', 'Нам'],
    ['we_v', 'Нам: що', 'частка від зростання'],
  ] },
  cta('guarantees', 'Готові почати з упевненістю?', 'Подивіться історичну дохідність стратегії або одразу створіть акаунт.'),
] };

const ADVANTAGES = { id: 'advantages', label: 'Переваги', path: '/advantages', sections: [
  { id: 'advantages.hero', label: 'Перший екран', fields: [
    ['badge', 'Мітка', 'Переваги'],
    ['title', 'Заголовок', 'Вигідніше\nза будь-яку альтернативу'],
    ['num_cap', 'Підпис біля великого числа', 'річних — проти ≈ 15% у S&P 500\nі −3% у готівки'],
    ['lead', 'Текст', 'Звичайний безготівковий рахунок в Interactive Brokers — з тією відмінністю, що кошти на ньому постійно зростають, зберігаються у валюті й за кордоном.'],
    ['chart_title', 'Діаграма: заголовок', 'Дохідність за рік'],
    ['chart_live', 'Діаграма: мітка', 'Наша стратегія'],
    ['bar1', 'Стовпчик 1: підпис', 'Ми'],
    ['bar1_val', 'Стовпчик 1: значення', '{returns_claim}'],
    ['bar2', 'Стовпчик 2: підпис', 'S&P 500'],
    ['bar2_val', 'Стовпчик 2: значення', '≈15%'],
    ['bar3', 'Стовпчик 3: підпис', 'Золото'],
    ['bar3_val', 'Стовпчик 3: значення', '≈10%'],
    ['bar4', 'Стовпчик 4: підпис', 'Нерухомість'],
    ['bar4_val', 'Стовпчик 4: значення', '≈8%'],
    ['bar5', 'Стовпчик 5: підпис', 'Вклад'],
    ['bar5_val', 'Стовпчик 5: значення', '≈5%'],
  ] },
  { id: 'advantages.marquee', label: 'Бігучий рядок', fields: [
    ['p1', 'Пункт 1', '{returns_claim} річних'],
    ['p2', 'Пункт 2', 'Кошти у валюті'],
    ['p3', 'Пункт 3', 'Активи за кордоном'],
    ['p4', 'Пункт 4', 'Вивід будь-коли'],
    ['p5', 'Пункт 5', '×3 до S&P 500'],
    ['p6', 'Пункт 6', 'Ризики ≈ 0'],
    ['p7', 'Пункт 7', 'Керування зі смартфона'],
    ['p8', 'Пункт 8', 'Захист від девальвації'],
  ] },
  { id: 'advantages.core', label: '01 · Ключові переваги', fields: [
    ['title', 'Заголовок', 'Ключові переваги'],
    ['sub', 'Підзаголовок', 'Головні причини, чому цей рахунок вигідніший за звичні способи зберігати гроші.'],
    ['main_title', 'Велика картка: заголовок', 'Велика дохідність'],
    ['main_text', 'Велика картка: текст', 'Цільовий показник стратегії — {returns_claim} річних на історичних даних. Кратно більше за будь-яку поширену альтернативу.'],
    ['c1_title', 'Картка 1: заголовок', 'Кошти доступні будь-коли'],
    ['c1_text', 'Картка 1: текст', 'Продати всі акції в адмінпанелі IB — кілька хвилин у робочі години; переказ на ваш рахунок — теж кілька хвилин, кошти надходять наступного дня.'],
    ['c2_title', 'Картка 2: заголовок', 'Кошти у валюті'],
    ['c2_text', 'Картка 2: текст', 'Капітал зберігається у валюті — захищений від знецінення гривні.'],
    ['c3_title', 'Картка 3: заголовок', 'Кошти за кордоном'],
    ['c3_text', 'Картка 3: текст', 'Активи зберігаються за кордоном, у надійній міжнародній юрисдикції.'],
    ['quote', 'Цитата під картками (*фраза* — виділення)', 'По суті це звичайний безготівковий рахунок — з тією відмінністю, що кошти на ньому *постійно зростають*. Ваше джерело доходу, яким зручно керувати просто зі смартфона.'],
  ] },
  { id: 'advantages.compare', label: '02 · Вигідніше за інші варіанти', fields: [
    ['title', 'Заголовок', 'Вигідніше за інші варіанти'],
    ['sub', 'Підзаголовок', 'Орієнтовне порівняння річної дохідності з поширеними альтернативами.'],
    ['anchor_label', 'Картка зліва: мітка', 'Наша стратегія'],
    ['anchor_cap', 'Картка зліва: підпис', 'річних, на історичних даних'],
    ['r1', 'Рядок 1: варіант', 'Готівка (USD)'],
    ['r1_val', 'Рядок 1: дохідність', '−3% / рік'],
    ['r1_note', 'Рядок 1: примітка (порожньо — без примітки)', 'Долар знецінюється ≈ −3%, євро ≈ −2.3% щороку.'],
    ['r2', 'Рядок 2: варіант', 'Валютний вклад'],
    ['r2_val', 'Рядок 2: дохідність', 'до 5% / рік'],
    ['r2_note', 'Рядок 2: примітка (порожньо — без примітки)', ''],
    ['r3', 'Рядок 3: варіант', 'Гривневий вклад'],
    ['r3_val', 'Рядок 3: дохідність', 'до 16% / рік'],
    ['r3_note', 'Рядок 3: примітка (порожньо — без примітки)', 'Гривня девальвує до долара ≈ 8% / рік.'],
    ['r4', 'Рядок 4: варіант', 'Золото'],
    ['r4_val', 'Рядок 4: дохідність', 'до 10% / рік'],
    ['r4_note', 'Рядок 4: примітка (порожньо — без примітки)', ''],
    ['r5', 'Рядок 5: варіант', 'Нерухомість'],
    ['r5_val', 'Рядок 5: дохідність', '≈ 8% / рік'],
    ['r5_note', 'Рядок 5: примітка (порожньо — без примітки)', ''],
    ['r6', 'Рядок 6: варіант', 'Власний бізнес'],
    ['r6_val', 'Рядок 6: дохідність', 'високі ризики'],
    ['r6_note', 'Рядок 6: примітка (порожньо — без примітки)', 'У нас ризики ≈ 0, без витрат часу, вивід будь-коли.'],
    ['r7', 'Рядок 7: варіант', 'S&P 500, buy & hold'],
    ['r7_val', 'Рядок 7: дохідність', '≈ 15% / рік'],
    ['r7_note', 'Рядок 7: примітка (порожньо — без примітки)', ''],
    ['r8', 'Рядок 8: варіант', 'Торгуєте самі'],
    ['r8_val', 'Рядок 8: дохідність', '2–6 год / день'],
    ['r8_note', 'Рядок 8: примітка (порожньо — без примітки)', 'Без людського фактору, великих ризиків і потреби глибоко розбиратись.'],
  ] },
  { id: 'advantages.crisis', label: '03 · А якщо настане світова криза?', fields: [
    ['badge', 'Мітка', 'Ризик під контролем'],
    ['title', 'Заголовок', 'А якщо настане світова криза?'],
    ['intro', 'Вступ', 'Так, така ймовірність існує. Але вона під контролем:'],
    ['p1', 'Пункт 1', 'Ви можете будь-коли за лічені хвилини вручну продати всі акції та вивести кошти — ціна акцій падає поступово, а не за хвилини.'],
    ['p2', 'Пункт 2', 'Під час кризи майже всі інші активи теж знеціняться — приблизно так само або більше.'],
    ['p3', 'Пункт 3', 'Криза може настати за рік, а може й через 15+ років.'],
    ['example_tag', 'Приклад: мітка', 'Приклад'],
    ['example', 'Приклад: текст', 'Криза настане за 2 роки. До того моменту ви вже заробите 95%+. Ціна акцій впаде умовно вдвічі (хоча ви зможете продати раніше) — ви вийдете в нуль, а наступного року заробите вже 45%+. В інших активах втрати були б значно більшими.'],
    ['concl', 'Висновок', 'Головна перевага рішення — висока дохідність, яка покриває всі можливі теоретичні збитки.'],
  ] },
  cta('advantages', 'Порахуйте свою вигоду', 'Подивіться історичну дохідність стратегії на обраному періоді або створіть акаунт.'),
] };

const PRICING = { id: 'pricing', label: 'Ціни', path: '/pricing', sections: [
  { id: 'pricing.hero', label: 'Перший екран', fields: [
    ['badge', 'Мітка', 'Ціни'],
    ['title', 'Заголовок', 'Платите лише\nза прибуток'],
    ['num', 'Велике число', '0%'],
    ['num_cap', 'Підпис біля числа', 'комісія на старті —\nторгуємо безкоштовно'],
    ['lead', 'Текст', 'Ми заробляємо тільки тоді, коли заробляєте ви. Комісія — це відсоток від чистого прибутку, який ми принесли на ваш рахунок.'],
    ['bill_title', 'Картка-рахунок: заголовок', 'Комісія за квартал'],
    ['bill_live', 'Картка-рахунок: мітка', 'Перші 6 місяців'],
    ['bill_profit', 'Картка-рахунок: рядок прибутку', 'Прибуток за квартал'],
    ['bill_fee', 'Картка-рахунок: рядок комісії', 'Ваша комісія (0%)'],
    ['bill_total', 'Картка-рахунок: до сплати', 'До сплати'],
    ['bill_free', 'Картка-рахунок: підпис суми', 'Безкоштовно до'],
    ['bill_badge', 'Картка-рахунок: мітка внизу', 'Без прихованих платежів'],
  ] },
  { id: 'pricing.marquee', label: 'Бігучий рядок', fields: [
    ['p1', 'Пункт 1', 'Перші 6 місяців безкоштовно'],
    ['p2', 'Пункт 2', 'До $10 000 — завжди безкоштовно'],
    ['p3', 'Пункт 3', 'Комісія лише від чистого прибутку'],
    ['p4', 'Пункт 4', 'Оплата раз на 3 місяці'],
    ['p5', 'Пункт 5', 'Готівка · крипто · банківський переказ'],
    ['p6', 'Пункт 6', 'Гарантія захисту вкладених коштів'],
  ] },
  { id: 'pricing.sections', label: 'Заголовки секцій', fields: [
    ['free_title', '01 · заголовок', 'Безкоштовні умови'],
    ['free_tag', '01 · мітка на картках', 'Безкоштовно'],
    ['tiers_title', '02 · заголовок', 'Скільки коштують наші послуги'],
    ['tiers_sub', '02 · підзаголовок', 'Вартість залежить від суми на вашому рахунку IBKR і береться у відсотках від чистого прибутку.'],
    ['tiers_flag', '02 · мітка на найвищому тарифі', 'Можлива знижка'],
    ['billing_title', '03 · заголовок', 'Як і коли відбувається оплата'],
    ['g_badge', '04 · мітка', 'У всіх тарифах'],
    ['g_title', '04 · заголовок', 'Гарантія захисту вкладених коштів'],
    ['g_lead', '04 · текст', 'У найгіршому випадку ми компенсуємо різницю, щоб сума на вашому рахунку ніколи не була меншою за всі ваші особисті вкладення за весь період.'],
    ['g_link', '04 · посилання', 'Детальніше про гарантії'],
  ] },
  cta('pricing', 'Порахуйте свій прибуток', 'Подивіться історичну дохідність стратегії на обраному періоді або одразу створіть акаунт.'),
] };

const HOW = { id: 'how', label: 'Як почати', path: '/how-to-start', sections: [
  { id: 'how.hero', label: 'Перший екран', fields: [
    ['badge', 'Мітка', 'Як почати?'],
    ['title', 'Заголовок', 'Запустіть алготрейдинг\nза 5 кроків'],
    ['num_cap', 'Підпис біля «$100»', 'мінімальна сума,\nщоб почати'],
    ['lead', 'Текст', 'Для старту потрібен відкритий рахунок в Interactive Brokers із коштами — навіть від мінімальних $100. Поповнювати чи виводити кошти можна будь-коли.'],
    ['flow_title', 'Картка-схема: заголовок', 'Шлях підключення'],
    ['flow_live', 'Картка-схема: мітка', 'Крок за кроком'],
    ['flow1', 'Картка-схема: ланка 1', 'Банківська картка'],
    ['flow2', 'Картка-схема: ланка 2', 'Платіжна система'],
    ['flow3', 'Картка-схема: ланка 3', 'SEPA-переказ'],
    ['flow4', 'Картка-схема: ланка 4', 'Interactive Brokers'],
    ['flow_value', 'Картка-схема: підпис часу', 'Час на підключення'],
    ['flow_badge', 'Картка-схема: мітка внизу', 'Тестовий платіж $100'],
  ] },
  { id: 'how.marquee', label: 'Бігучий рядок', fields: [
    ['p1', 'Пункт 1', '5 кроків до старту'],
    ['p2', 'Пункт 2', 'Мінімум $100 для початку'],
    ['p3', 'Пункт 3', 'IBKR + платіжні системи'],
    ['p4', 'Пункт 4', 'Тестовий платіж перед стартом'],
    ['p5', 'Пункт 5', 'Податок лише з чистого прибутку'],
    ['p6', 'Пункт 6', 'Пільга до $250 000 у воєнний стан'],
  ] },
  { id: 'how.steps', label: '01 · 5 кроків до старту', fields: [
    ['title', 'Заголовок', '5 кроків до старту'],
    ['sub', 'Підзаголовок', 'Ми не приймаємо ваші кошти на свої рахунки — усе зберігається на вашому рахунку в Interactive Brokers.'],
    ['s1_title', 'Крок 1: заголовок', 'Відкрийте рахунок в Interactive Brokers'],
    ['s1_text', 'Крок 1: текст', 'Зареєструйтеся на InteractiveBrokers.co.uk — саме там реєструються клієнти з Європи, зокрема з України.'],
    ['s1_note1', 'Крок 1: примітка 1 (порожньо — без неї)', 'InteractiveBrokers.com — для клієнтів зі США та інших регіонів.'],
    ['s1_note2', 'Крок 1: примітка 2 (порожньо — без неї)', ''],
    ['s2_title', 'Крок 2: заголовок', 'Зареєструйтеся в платіжних системах'],
    ['s2_text', 'Крок 2: текст', 'Створіть акаунт у Wise.com та/або Genome.eu, Transfergo.com, Zen.com — через них кошти підуть за кордон.'],
    ['s2_note1', 'Крок 2: примітка 1 (порожньо — без неї)', 'Звичайні SWIFT/Wire-перекази за кордон для фізосіб з України заборонені (виняток — лікування, навчання, аліменти, з документальним підтвердженням).'],
    ['s2_note2', 'Крок 2: примітка 2 (порожньо — без неї)', 'Wise приймає лише картки Mastercard (номер починається на 5) — такі є в Укргазбанку, ПриватБанку, ПУМБ та інших.'],
    ['s3_title', 'Крок 3: заголовок', 'Налаштуйте ланцюжок поповнення'],
    ['s3_text', 'Крок 3: текст', 'Відкрийте валютні картки (USD/EUR) у додатках українських банків. Внесіть на них кошти → поповніть платіжну систему оплатою картки на її сайті (як в інтернет-магазині, не SWIFT) → надішліть SEPA-переказ у євро в Interactive Brokers → конвертуйте євро в USD уже в IB.'],
    ['s3_note1', 'Крок 3: примітка 1 (порожньо — без неї)', 'Спершу зробіть тестовий платіж (наприклад, $100), щоб перевірити кожну ланку ланцюжка.'],
    ['s3_note2', 'Крок 3: примітка 2 (порожньо — без неї)', ''],
    ['s4_title', 'Крок 4: заголовок', 'Підключіть рахунок до Trading.com.ua'],
    ['s4_text', 'Крок 4: текст', 'Зареєструйтеся в Trading.com.ua, підключіть рахунок Interactive Brokers — і наша система автоматично почне торгувати акціями на вашому рахунку.'],
    ['s4_note1', 'Крок 4: примітка 1 (порожньо — без неї)', ''],
    ['s4_note2', 'Крок 4: примітка 2 (порожньо — без неї)', ''],
    ['s5_title', 'Крок 5: заголовок', 'Якщо у вас уже є акції в IB'],
    ['s5_text', 'Крок 5: текст', 'Алгоритм розпоряджається лише доступними коштами та купленими на них акціями. Ваші наявні акції він запам’ятовує і ніколи не чіпає.'],
    ['s5_note1', 'Крок 5: примітка 1 (порожньо — без неї)', 'Щоб задіяти наявні акції — продайте їх в адмінпанелі Interactive Brokers: алгоритм побачить вільні кошти й почне торгувати на власний розсуд.'],
    ['s5_note2', 'Крок 5: примітка 2 (порожньо — без неї)', ''],
  ] },
  { id: 'how.tax', label: '02 · Податки та CRS', fields: [
    ['badge', 'Мітка', 'Пільга воєнного стану'],
    ['title', 'Заголовок', 'Податки та обмін інформацією (CRS)'],
    ['text', 'Текст (порожній рядок — новий абзац)', 'Ваш рахунок буде в **InteractiveBrokers.co.uk** (Англія). Англія бере участь в обміні податковою інформацією **CRS** (Common Reporting Standard — автоматичний обмін даними про фінансові рахунки між податковими органами країн), тож українська податкова знатиме про доходи.\n\nДохід від торгівлі акціями оподатковується як інвестиційний прибуток: загальна ставка **{tax_pct}%** (18% ПДФО + 5% військовий збір) — і лише з **чистого прибутку** (різниці між ціною продажу та купівлі акцій). В Interactive Brokers є вся потрібна звітність у зручному для української податкової форматі.'],
    ['stat_label', 'Число справа: підпис', 'Поріг звільнення від автоматичних податків'],
    ['stat_note', 'Число справа: примітка', 'станом на 31 грудня, на період дії воєнного стану — понад цю суму рішення про сплату податків залишається за вами.'],
    ['quote', 'Цитата', '«…не вважається податковою інформацією… інформація… яка стосується фінансового рахунку громадянина України… якщо сукупний залишок або вартість усіх фінансових рахунків, власником яких є одна особа — громадянин України, не перевищує еквівалент 250 тисяч доларів США станом на 31 грудня календарного року, який припадає на період дії воєнного стану…» (п. 53-1.4 ПКУ)'],
    ['source', 'Посилання на джерело: текст', 'Джерело: zakon.rada.gov.ua'],
  ] },
  { id: 'how.info', label: 'Корисна інформація', fields: [
    ['title', 'Заголовок', 'Корисна інформація'],
    ['sub', 'Підзаголовок', 'Практичні нюанси щодо переказів і документів для клієнтів з України.'],
    ['q1', 'Питання 1', 'Ліміти на конвертацію та перекази (НБУ)'],
    ['a1', 'Відповідь 1 (порожній рядок — новий абзац)', 'Конвертувати гривню у валюту онлайн можна на суму до **50 000 грн/міс** в одному банку. Для більших сум поповнюйте валютну картку готівкою в касі банку.\n\nЛіміт на покупки за кордоном (поповнення платіжних систем) — **100 000 грн/міс** з одного банку (з усіх його карток). Для більших обсягів використовуйте картки різних банків — в обласному центрі зазвичай 20+ банків.\n\nДля дуже великих обсягів — відкриття рахунку за кордоном, перевезення готівки через кордон і поповнення на місці, далі SEPA-переказ у Interactive Brokers.'],
    ['q2', 'Питання 2', 'Підтвердження походження коштів'],
    ['a2', 'Відповідь 2 (порожній рядок — новий абзац)', 'Від певного обсягу Interactive Brokers може запитати про походження коштів. Підійде довідка про доходи або довідка про продаж майна (з нотаріально засвідченим перекладом англійською).\n\n**Приклад.** Оформлення купівлі-продажу нерухомості в межах родини (прізвища та місця прописки покупця і продавця мають відрізнятися): кошти фактично не сплачуються, а договір пояснює походження. Якщо нерухомість була у власності понад 3 роки — податки мінімальні.\n\nДовідка про продаж майна підходить і для Interactive Brokers, і для митниці при декларуванні, і для закордонного банку при внесенні коштів.'],
    ['q3', 'Питання 3', 'Перевезення коштів і виїзд за кордон'],
    ['a3', 'Відповідь 3 (порожній рядок — новий абзац)', 'До **$10 000 / €10 000** на особу можна перевозити без декларування; понад — лише з декларуванням і документами про походження коштів.\n\nЯкщо у вас немає можливості перетинати кордон — це може зробити дружина чи мати, відкривши всі рахунки на себе, і надіслати кошти на свій рахунок в Interactive Brokers або вам у платіжну систему, звідки ви поповните власний рахунок IB.'],
  ] },
  cta('how', 'Готові почати з упевненістю?', 'Подивіться історичну дохідність стратегії або одразу створіть акаунт.'),
] };

const CONTACTS = { id: 'contacts', label: 'Контакти', path: '/contacts', sections: [
  { id: 'contacts.page', label: 'Заголовок сторінки', fields: [
    ['title', 'Заголовок', "Зв'яжіться з нами"],
    ['lead', 'Текст', 'Маєте запитання чи хочете почати? Напишіть нам або завітайте до офісу — відповімо найближчим часом.'],
    ['addr_label', 'Підпис адреси', 'Адреса'],
  ] },
  { id: 'contacts.form', label: 'Форма запиту', fields: [
    ['title', 'Заголовок форми', 'Надіслати запит'],
    ['name', 'Поле «Ім’я»', "Ім'я"],
    ['name_ph', 'Підказка в полі імені', "Ваше ім'я"],
    ['phone', 'Поле «Телефон»', 'Телефон'],
    ['email', 'Поле «Email»', 'Email'],
    ['text', 'Поле «Текст»', 'Текст'],
    ['text_ph', 'Підказка в полі тексту', 'Ваше повідомлення…'],
    ['attach', 'Кнопка файлів', 'Прикріпити файли'],
    ['submit', 'Кнопка', 'Надіслати запит'],
    ['sending', 'Кнопка під час надсилання', 'Надсилаємо…'],
    ['err_name', 'Помилка: немає імені', "Введіть ім'я"],
    ['err_phone', 'Помилка: немає телефону', 'Введіть телефон'],
    ['err_email', 'Помилка: поганий email', 'Некоректний email'],
    ['err_text', 'Помилка: немає тексту', 'Введіть текст повідомлення'],
    ['err_send', 'Помилка надсилання', 'Не вдалося надіслати. Спробуйте пізніше або скористайтесь телефоном/Telegram.'],
    ['ok_title', 'Після надсилання: заголовок', 'Дякуємо! Запит надіслано'],
    ['ok_text', 'Після надсилання: текст', "Ми отримали ваше повідомлення і зв'яжемося з вами найближчим часом."],
    ['ok_again', 'Після надсилання: кнопка', 'Надіслати ще один запит'],
  ] },
] };

const DEMO = { id: 'demo', label: 'Демо-кабінет', path: '/demo', sections: [
  { id: 'demo.banner', label: 'Жовта плашка вгорі', fields: [
    ['text', 'Текст', 'Це приклад вашої адмінсторінки з довільними даними. Для реальних чи віртуальних торгів [зареєструйтесь](/register) чи [залогіньтесь](/login)'],
  ] },
] };

export const PAGES_OTHER = [RETURNS, GUARANTEES, ADVANTAGES, PRICING, HOW, CONTACTS, DEMO];
